import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import FeaturedStays from "@/components/site/FeaturedStays";
import CorporateCta from "@/components/site/CorporateCta";
import WhoWeAre from "@/components/site/WhoWeAre";
import Services from "@/components/site/Services";
import Why from "@/components/site/Why";
import Manifesto from "@/components/site/Manifesto";
import Marquee from "@/components/site/Marquee";
import Process from "@/components/site/Process";
import Pricing from "@/components/site/Pricing";
import Testimonial from "@/components/site/Testimonial";
import OwnerCta from "@/components/site/OwnerCta";
import BookCta from "@/components/site/BookCta";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="bg-white text-[#222222]" data-testid="landing-page">
      <Header />
      <main>
        {/* 1. Guests & companies first */}
        <Hero />
        <FeaturedStays />
        <CorporateCta />
        <WhoWeAre />

        {/* 2. Existing owner / management content */}
        <div id="boligejere" data-testid="boligejere-anchor" />
        <Marquee />
        <Services />
        <Why />
        <Testimonial />
        <Manifesto />
        <Process />
        <Pricing />

        {/* 3. Owner acquisition */}
        <OwnerCta />
        <BookCta />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
